// La roadmap du produit, sans dates : ce qu'on prévoit, pas une promesse de
// livraison. Quand un sujet est livré, il quitte ce fichier : il apparaît dans
// le journal des versions.

export interface RoadmapItem {
  name: string;
  detail: string;
}

export interface RoadmapStage {
  title: string;
  items: RoadmapItem[];
}

export const ROADMAP: RoadmapStage[] = [
  {
    title: 'Prochainement',
    items: [
      {
        name: 'Nouvelle étude : partir du pourquoi',
        detail: 'Dire sur quelle fonctionnalité ou quel problème porte l’étude, puis laisser un assistant conseiller la méthode et les démarches. Le choix manuel reste possible.',
      },
      {
        name: 'Taxonomie suggérée',
        detail: 'Un bouton qui propose une taxonomie à partir des études du projet, à valider proposition par proposition.',
      },
      {
        name: 'Retours en continu',
        detail: 'Recevoir les retours du script intégré au produit sans dépendre d’une enquête ouverte.',
      },
      {
        name: 'Mot de passe oublié',
        detail: 'Retrouver l’accès à son compte en autonomie.',
      },
    ],
  },
  {
    title: 'À l’étude',
    items: [
      {
        name: 'Import de métriques',
        detail: 'Reprendre ses chiffres d’usage depuis un fichier CSV.',
      },
      {
        name: 'Suivi d’usage par le script',
        detail: 'Compléter les retours déclarés par ce que les utilisateurs font dans le produit.',
      },
    ],
  },
  {
    title: 'Plus tard',
    items: [
      {
        name: 'Zygosight dans Claude',
        detail: 'Piloter ses études, ses insights et l’adoption depuis Claude.',
      },
      {
        name: 'Version 1.0',
        detail: 'La fin de la bêta et le lancement commercial, avec l’offre payante.',
      },
    ],
  },
];
